import React from 'react';

interface TaxInfoProps {
  itemizationInfo: {
    standardDeduction: number;
    itemizedYears: number[];
  };
}

export const TaxInfo: React.FC<TaxInfoProps> = ({ itemizationInfo }) => {
  if (!itemizationInfo) {
    return null;
  }

  const { itemizedYears } = itemizationInfo;

  const message = itemizedYears.length > 0
    ? "This calculation automatically applies the mortgage interest deduction for any year your projected interest exceeds your standard deduction."
    : "Your projected annual interest doesn't exceed your standard deduction in any year, so no mortgage interest tax savings will be applied.";

  return (
    <div className="mt-4 p-3 bg-blue-50 border-l-4 border-blue-400 text-sm text-blue-800 rounded-r-lg">
      <div className="flex items-start">
        <div>
          <svg className="h-5 w-5 mr-2 mt-0.5 text-blue-500 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        <div>
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};